import React from 'react';
import { observer } from 'mobx-react';
import { CapacityPlannerScreen } from '../../screen/CapacityPlanner/Screen';

interface Props { planner: CapacityPlannerScreen; }

@observer
export class Sidebar extends React.Component<Props> {
    render() {
        const p = this.props.planner;
        return (
            <aside className="sidebar">
                <h2>Team</h2>
                <div className="developer-list">
                    {p.users.map(u => {
                        const uAny = u as any;
                        const allocation = p.getDeveloperAllocation(u.id as any);
                        const percentage = (allocation.totalDays / 5) * 100;
                        const weeklyHours = p.getDevWeeklyHours(uAny);
                        const isPartTime = p.isPartTime(uAny);
                        const upcomingHolidays = p.holidays.filter(h => (h as any).user?.id === u.id && h.startDate && new Date(h.startDate) > new Date()).length;
                        return (
                            <div key={u.id} className="developer-card" data-test-cp-developer-card onClick={() => p.openDeveloperModal(u.id as any)}>
                                <div className="name">{uAny.fullName || `${uAny.firstName} ${uAny.lastName}`}</div>
                                <div className="capacity">{allocation.totalDays}/5 days allocated</div>
                                <div className={'work-hours' + (isPartTime ? ' part-time' : '')}>
                                    {weeklyHours}h/week{isPartTime ? ' (part-time)' : ''}{upcomingHolidays ? ` · ${upcomingHolidays} holiday` : ''}
                                </div>
                                <div className="capacity-bar">
                                    <div className={'capacity-fill' + (allocation.isOverallocated ? ' overallocated' : '')} style={{ width: `${Math.min(percentage, 100)}%` }} />
                                </div>
                            </div>
                        );
                    })}
                </div>
            </aside>
        );
    }
}
